/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_HomeInputs */

const es_nav_aria_home = /** @type {(inputs: Nav_Aria_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar inicio`)
};

const gl_nav_aria_home = /** @type {(inputs: Nav_Aria_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar inicio`)
};

const en_nav_aria_home = /** @type {(inputs: Nav_Aria_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar home`)
};

/**
* | output |
* | --- |
* | "Zarpar home" |
*
* @param {Nav_Aria_HomeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_aria_home = /** @type {((inputs?: Nav_Aria_HomeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_HomeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_aria_home(inputs)
	if (locale === "en") return en_nav_aria_home(inputs)
	return es_nav_aria_home(inputs)
});